import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { ChangeSearchForm } from './internals/change-search-form';
import { CollapsibleSearchForm } from './internals/collapsible-search-form';
import { SharedUiUniversalSearchFormWrapper } from '../../common/universal-search-form/universal-search-form-wrapper';

export const UniversalSearchFormExperiment = () => (
  <Experiment name="SharedUI_Search_Form_SRP_Integration">
    <ExperimentControl>
      <Viewport>
        <ViewSmall>
          <CollapsibleSearchForm />
        </ViewSmall>
        <ViewMedium>
          <ChangeSearchForm />
        </ViewMedium>
      </Viewport>
    </ExperimentControl>
    <ExperimentVariant bucket={1}>
      <SharedUiUniversalSearchFormWrapper />
    </ExperimentVariant>
  </Experiment>
);
